import React, { useEffect } from "react";
import "./image-checkbox.scss";
import CheckIcon from "../../../assets/images/steps/check-circle.svg";

export interface ImageCheckboxItem {
  Image: string;
  Label: string;
  Value: string;
  OnClick: Function;
}
export interface ImageCheckboxProps {
  Items: ImageCheckboxItem[];
  Size: "small" | "large";
  Multiselect: boolean;
  OnSelect: Function
}

export const ImageCheckboxComponent = ({
  Items,
  Size,
  Multiselect,
  OnSelect,
}: ImageCheckboxProps): JSX.Element => {
  const [SelectedItem, SetSelectedItem] = React.useState("");
  const [SelectedItems, SetSelectedItems] = React.useState<string[]>([]);

  useEffect(() => {
    if (Items.length > 0) {
      if (!Multiselect) {
        SetSelectedItem(Items[0].Value);
      } 
    }
  }, []);

  return (
    <>
      <div className={["image-checkbox-container", Size].join(" ")}>
        {Items.map((Item, Index) => {
          return (
            <div
              key={`checkbox-item-${Index}-${Item.Value}`}
              className={[
                "image-checkbox-item",
                (!Multiselect ? SelectedItem === Item.Value : SelectedItems.includes(Item.Value)) && "selected",
              ].join(" ")}
              onClick={() => {
                if (!Multiselect) {
                    SetSelectedItem(Item.Value);
                    OnSelect(Item.Value);
                } else {
                    if (SelectedItems.includes(Item.Value)) {
                        SetSelectedItems(SelectedItems.filter((i) => i !== Item.Value));
                        OnSelect(SelectedItems.filter((i) => i !== Item.Value));
                    } else {
                        SetSelectedItems([...SelectedItems, Item.Value]);
                        OnSelect([...SelectedItems, Item.Value]);
                    }
                }
              }}
            >
              <div className="check-icon-container">
                <img
                  className={[
                    "image-checkbox-check-icon",
                    (!Multiselect ? SelectedItem === Item.Value : SelectedItems.includes(Item.Value)) ? "checked" : "unchecked",
                  ].join(" ")}
                  src={CheckIcon}
                />
              </div>
              <img
                className="image-checkbox-image"
                src={Item.Image}
                alt={Item.Label}
              />
              <div className="image-checkbox-label">{Item.Label}</div>
            </div>
          );
        })}
      </div>
    </>
  );
};
